import React, {useEffect, useState} from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import axios from 'axios';
import {t} from 'react-switch-lang';

import {BASE_URL, courtRiskId, incurredRiskId, potentialRiskId} from '../../utils/const';
import './TableWithNotification.scss';
import {MarkAsReadApi} from '../../services/notifications/NotificationsApi';
import {DeleteNotification} from '../modals/ModalDeleteNotification';
import {getRisk, getCourtRisk} from '../../services/getRisk';
import {getMeasure} from '../../services/measuresService/measuresApi';

const TableWithUnreadNotification = ({message, setRowChanged}) => {
  const [items, setItems] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [delivered, setDelivered] = useState(false);

  const stylesWidth = {width: `100%`, minWidth: '150px'};

  const container_width = stylesWidth.length * 150 + 40;

  const containerStyles = {
    // maxHeight: "100%",
    minWidth: `${container_width + 20}px`,
    // paddingTop: "20px",
    // overflowY: "auto",
    // overflowX: "unset !important"
  };


  let revisionAndFindingLinkFun=(revisionId,findingID)=>{
      if (findingID){
        window.location = `/revisions/${revisionId}/findings/${findingID}`;
      }else{
        window.location = `/revisions/${revisionId}`;
      }
  }


  let riskLinkFun = (id) => {
    getRisk(id)
      .then((r) => {
        if (r.data.riskTypeId === potentialRiskId) {
          window.location = `/potential-risk/${id}`;
        } else if (r.data.riskTypeId === incurredRiskId) {
          window.location = `/incurred-risk/${id}`;
        } else if (r.data.riskTypeId === courtRiskId) {
          getCourtRisk(id).then((r) => {
            window.location = `/court-risk/${r.data[0].id}`;
          })
          .catch((r) => {
            window.location = '/403';
          });
        }
      })
      .catch((r) => {
        window.location = '/403';
      });
  };

  let externalizationLinkFun=(id, formKey)=>{
    if (id){
      window.location = `/externalizations/${id}?tab=${formKey}`;
    }else{
      window.location = '/403';
    }
  }

  const keyIndicatorLink= (id) => {
    if (id){
      window.location = `/key-risk-indicators/${id}`;
    }else{
      window.location = '/403';
    }
  }

  let riskId;
  let measuresLinkFun = (id) => {
    getMeasure(id).then((r) => {
      riskId = r.data.riskId;

      getRisk(riskId)
        .then((r) => {
          if (r.data.riskTypeId === potentialRiskId) {
            window.location = `/potential-risk/${riskId}?tab=measures&measure=${id}`;
          } else if (r.data.riskTypeId === incurredRiskId) {
            window.location = `/incurred-risk/${riskId}?tab=measures&measure=${id}`;
          } else if (r.data.riskTypeId === courtRiskId) {
            getCourtRisk(riskId).then((r) => {
              window.location = `/court-risk/${r.data[0].id}?tab=measures&measure=${id}`;
            })
            .catch((r) => {
              window.location = '/403';
            });
          }
        })
        .catch((r) => {
          window.location = '/403';
        });
    });
  };

  const fetchMoreData = () => {
    axios
      .get(`${BASE_URL}/notifications/unread?page=0&size=1000&sort=sentAt,desc`)
      .then((res) => {
        if (res.data.length !== 0) {
          const newData = items;
          res.data.map((item) => newData.push(item));
          setItems(prevState => [...newData]);
        }
      });
    if (hasMore) {
      axios
        .get(
          `${BASE_URL}/notifications/delivered?page=${pageNumber}&sort=sentAt,desc`
        )
        .then((res) => {
          if (res.data.length !== 0) {
            const newData = items;
            res.data.map((item) => newData.push(item));

            setItems(newData);
            if (res.data.length === 20) {
              setHasMore(true);
            }
          } else {
            setIsLoading(false);
            setHasMore(false);
          }
          setPageNumber(pageNumber + 1);
        })
        .catch((r) => {
          setIsLoading(false);
        });
    }

  };

  useEffect(() => {
    setDelivered(false);
    setHasMore(true);
  }, []);

  function readThisNotification(id) {
    MarkAsReadApi(id).then((res) => {
      if (res === 'success') {
        setRowChanged();
      }
    });
  }

  useEffect(() => {
    fetchMoreData();
  }, []);
  return (
    <div>
      <div
        className="table-administration-container navbarNotification"
        id="table-container"
        style={containerStyles}
      >
        <InfiniteScroll
          dataLength={items.length}
          next={fetchMoreData && (() => fetchMoreData())}
          hasMore={hasMore}
          loader={isLoading ? <div className="loader"></div> : ''}
          scrollableTarget="table-container"
          scrollThreshold={0.7}
        >
          {items.length > 0 ? (
            items.map((item, index) => (
              <div className="navNotificationCard" key={index}>
                {message === 'unread' ? (
                  <div className="readNotification">
                    <div className="popForRead">{t(`notification.read`)}</div>
                    <div className="popForRead1"></div>
                    <button
                      className="read"
                      onClick={() => readThisNotification(item.id)}
                    >
                      <img src="/images/XWhite.svg" alt="x" />
                    </button>
                  </div>
                ) : (
                  ''
                )}

                <div className="navNotificationHeader">
                  <div
                    className={`navNotificationColor ${item.notificationType.color}`}
                  ></div>
                  <div>
                    <div className="navNotificationSubject">{item.subject}</div>
                    {item.sentAt !== null ? (
                      <div className="navNotificationDate">
                        {item.sentAt
                          .slice(0, 10)
                          .split('-')
                          .reverse()
                          .join('.')}{' '}
                        - {item.sentAt.slice(11, 16)}h
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className="navNotificationBody">{item.body}</div>
                {item.riskId !== null ? (
                  <div className="navNotificationLink">
                    <br />
                    <p
                      onClick={() => riskLinkFun(item.riskId)}
                      className="w-100 d-block risk-link-p"
                      id={item.id}
                    >
                      {t(`notification.riskLink`)} {item.riskTypeId === 3 ? item.courtRiskId : item.riskId}
                    </p>
                  </div>
                ) : item.measuresId !== null ? (
                  <div className="navNotificationLink">
                    <br />
                    <p
                      onClick={() => measuresLinkFun(item.measuresId)}
                      className="w-100 d-block risk-link-p"
                      id={item.id}
                    >
                      {t(`notification.measuresLink`)} {item.measuresId}
                    </p>
                  </div>
                ) : item.revisionId !== null ? (
                    <div className="navNotificationLink">
                      <br />
                      <p
                          onClick={() => revisionAndFindingLinkFun(item.revisionId,item.findingId)}
                          className="w-100 d-block risk-link-p"
                          id={item.id}
                      >
                        {item.findingId ? t(`notification.findingLink`) : t(`notification.revisionLink`)}
                      </p>
                    </div>
                ): item?.externalizationId !== null ?  (
                        <div className="navNotificationLink">
                          <br />
                          <p onClick={() => externalizationLinkFun(item?.externalizationId, item?.formKey)}
                            className="w-100 d-block risk-link-p"
                            id={item.id}>
                            {t(`notification.externalizationLink`)} {item?.externalizationId ? item?.externalizationId : ''}
                          </p>
                        </div>
                      )
                : item?.keyIndicatorId !== null ?  (
                    <div className="navNotificationLink">
                      <br />
                      <p onClick={() => keyIndicatorLink(item?.keyIndicatorId)}
                         className="w-100 d-block risk-link-p"
                         id={item.id}>
                        {t(`notification.keyIndicatorLink`)} {item?.keyIndicatorId ? item?.keyIndicatorId : ''}</p>
                    </div>
                  ) : (
                  ''
                )}
                {message === 'unread' ? (
                  <DeleteNotification
                    id={item.id}
                    subject={item.subject}
                    setRowChanged={() => setRowChanged()}
                  />
                ) : message === 'read' ? (
                  <DeleteNotification
                    id={item.id}
                    subject={item.subject}
                    setRowChanged={() => setRowChanged()}
                  />
                ) : (
                  ''
                )}
              </div>
            ))
          ) : (
            <div className="mx-auto navNoMessage text-center">
              <img src="/images/NoMessage.svg" alt="noMessage" />
              <br />
              {t(
                `notification.no${message.replace(/^\w/, (c) =>
                  c.toUpperCase()
                )}Message`
              )}
            </div>
          )}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default TableWithUnreadNotification;
